{
  "shared-user-preferences-onboarding.modal.alternative-text": [
    {
      "type": 0,
      "value": "Alternatively, you can choose light or dark theme from your display settings in your account."
    }
  ],
  "shared-user-preferences-onboarding.modal.button.accept": [
    {
      "type": 0,
      "value": "Accept"
    }
  ],
  "shared-user-preferences-onboarding.modal.button.choose-theme": [
    {
      "type": 0,
      "value": "Choose theme"
    }
  ],
  "shared-user-preferences-onboarding.modal.description": [
    {
      "type": 0,
      "value": "All your Atlassian apps will now match your browser's theme by default."
    }
  ],
  "shared-user-preferences-onboarding.modal.feature.consistent": [
    {
      "type": 0,
      "value": "Consistent look and feel across all apps"
    }
  ],
  "shared-user-preferences-onboarding.modal.feature.override": [
    {
      "type": 0,
      "value": "Override theme preferences for certain apps"
    }
  ],
  "shared-user-preferences-onboarding.modal.feature.set-once": [
    {
      "type": 0,
      "value": "Only set your theme preferences once"
    }
  ],
  "shared-user-preferences-onboarding.modal.title": [
    {
      "type": 0,
      "value": "Your theme is now synced"
    }
  ]
}